module.exports = __webpack_public_path__ + "static/media/Lee.de16a2b1.png";